// extracted by mini-css-extract-plugin
export default {"labeledValue":"LabeledValue_labeledValue__x+cOP"};